export default (ref) => !ref?.current.value;
